import React from 'react'
import { useApp } from '../hooks/useApp'
import { useBrandingContext } from '../contexts/BrandingContext'

function Footer() {
  const { appVersion } = useApp()
  const { branding } = useBrandingContext()

  return (
    <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between text-sm text-muted-foreground">
          <span className="font-medium">{branding.site_name}</span>
          <span>v{appVersion}</span>
        </div>
      </div>
    </footer>
  )
}

export default Footer